import type { FuelPriceHistoryResponse } from "../../hooks/react-query/backOffice/useFuelPriceHistory";

export const mockFuelPriceApiResponse = {
  success: true,
  message: "Fuel price data retrieved successfully",
  errorCode: null,
  item: {
    fuelPrices: [
      {
        id: 11,
        displayName: "California",
        effectiveDate: "02/23/2026",
        price: "4.944",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "1.73",
      },
      {
        id: 10,
        displayName: "PADD5 Except California",
        effectiveDate: "02/23/2026",
        price: "4.050",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.02",
      },
      {
        id: 9,
        displayName: "PADD5",
        effectiveDate: "02/23/2026",
        price: "4.465",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "1.87",
      },
      {
        id: 8,
        displayName: "PADD4",
        effectiveDate: "02/23/2026",
        price: "3.683",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: true,
        changePrice: "0.08",
        changePercentage: "2.11",
      },
      {
        id: 7,
        displayName: "PADD3",
        effectiveDate: "02/23/2026",
        price: "3.489",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.26",
      },
      {
        id: 6,
        displayName: "PADD2",
        effectiveDate: "02/23/2026",
        price: "3.798",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.13",
        changePercentage: "3.66",
      },
      {
        id: 5,
        displayName: "PADD1C",
        effectiveDate: "02/23/2026",
        price: "3.708",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.10",
        changePercentage: "2.66",
      },
      {
        id: 4,
        displayName: "PADD1B",
        effectiveDate: "02/23/2026",
        price: "4.104",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.07",
        changePercentage: "1.84",
      },
      {
        id: 3,
        displayName: "PADD1A",
        effectiveDate: "02/23/2026",
        price: "4.201",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "-0.01",
        changePercentage: "-0.33",
      },
      {
        id: 2,
        displayName: "PADD1",
        effectiveDate: "02/23/2026",
        price: "3.843",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.13",
      },
      {
        id: 1,
        displayName: "National",
        effectiveDate: "02/23/2026",
        price: "3.809",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.10",
        changePercentage: "2.64",
      },
    ],
  },
};

// Mock data for fuel price history - matches API response structure
// Each entry uses fuelPriceId as key
export const mockFuelPriceHistoryResponses: Record<
  number,
  FuelPriceHistoryResponse
> = {
  1: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 1,
          fuelPriceId: 1,
          price: "3.809",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "John Smith",
          modifiedOn: "02/24/2026",
        },
        {
          id: 2,
          fuelPriceId: 1,
          price: "3.759",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Sarah Johnson",
          modifiedOn: "02/17/2026",
        },
        {
          id: 3,
          fuelPriceId: 1,
          price: "3.709",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Michael Brown",
          modifiedOn: "02/10/2026",
        },
        {
          id: 4,
          fuelPriceId: 1,
          price: "3.689",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Emily Davis",
          modifiedOn: "02/03/2026",
        },
        {
          id: 5,
          fuelPriceId: 1,
          price: "3.729",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "David Wilson",
          modifiedOn: "01/27/2026",
        },
        {
          id: 6,
          fuelPriceId: 1,
          price: "3.799",
          effectiveDate: "01/19/2026",
          createdBy: "System",
          createdOn: "01/19/2026",
          modifiedBy: "Lisa Anderson",
          modifiedOn: "01/20/2026",
        },
        {
          id: 7,
          fuelPriceId: 1,
          price: "3.849",
          effectiveDate: "01/12/2026",
          createdBy: "System",
          createdOn: "01/12/2026",
          modifiedBy: "Robert Martinez",
          modifiedOn: "01/13/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 2,
        totalRecords: 8,
        pageSize: 7,
      },
    },
  },
  2: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 10,
          fuelPriceId: 2,
          price: "3.843",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Mark Johnson",
          modifiedOn: "02/24/2026",
        },
        {
          id: 11,
          fuelPriceId: 2,
          price: "3.793",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Amanda Lee",
          modifiedOn: "02/17/2026",
        },
        {
          id: 12,
          fuelPriceId: 2,
          price: "3.763",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Christopher White",
          modifiedOn: "02/10/2026",
        },
        {
          id: 13,
          fuelPriceId: 2,
          price: "3.713",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Nicole Harris",
          modifiedOn: "02/03/2026",
        },
        {
          id: 14,
          fuelPriceId: 2,
          price: "3.753",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Daniel Clark",
          modifiedOn: "01/27/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 5,
        pageSize: 7,
      },
    },
  },
  3: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 20,
          fuelPriceId: 3,
          price: "4.201",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Patricia Moore",
          modifiedOn: "02/24/2026",
        },
        {
          id: 21,
          fuelPriceId: 3,
          price: "4.211",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Kevin Thompson",
          modifiedOn: "02/17/2026",
        },
        {
          id: 22,
          fuelPriceId: 3,
          price: "4.181",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Rachel Garcia",
          modifiedOn: "02/10/2026",
        },
        {
          id: 23,
          fuelPriceId: 3,
          price: "4.151",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Brian Martinez",
          modifiedOn: "02/03/2026",
        },
        {
          id: 24,
          fuelPriceId: 3,
          price: "4.191",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Angela Robinson",
          modifiedOn: "01/27/2026",
        },
        {
          id: 25,
          fuelPriceId: 3,
          price: "4.231",
          effectiveDate: "01/19/2026",
          createdBy: "System",
          createdOn: "01/19/2026",
          modifiedBy: "Steven Walker",
          modifiedOn: "01/20/2026",
        },
        {
          id: 26,
          fuelPriceId: 3,
          price: "4.271",
          effectiveDate: "01/12/2026",
          createdBy: "System",
          createdOn: "01/12/2026",
          modifiedBy: "Steven",
          modifiedOn: "01/13/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 2,
        totalRecords: 14,
        pageSize: 7,
      },
    },
  },
  4: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 40,
          fuelPriceId: 4,
          price: "4.104",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Michelle Hall",
          modifiedOn: "02/24/2026",
        },
        {
          id: 41,
          fuelPriceId: 4,
          price: "4.034",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Jason Allen",
          modifiedOn: "02/17/2026",
        },
        {
          id: 42,
          fuelPriceId: 4,
          price: "3.994",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Stephanie Young",
          modifiedOn: "02/10/2026",
        },
        {
          id: 43,
          fuelPriceId: 4,
          price: "3.964",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Timothy King",
          modifiedOn: "02/03/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 4,
        pageSize: 7,
      },
    },
  },
  5: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 50,
          fuelPriceId: 5,
          price: "3.708",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Rebecca Wright",
          modifiedOn: "02/24/2026",
        },
        {
          id: 51,
          fuelPriceId: 5,
          price: "3.608",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Gregory Lopez",
          modifiedOn: "02/17/2026",
        },
        {
          id: 52,
          fuelPriceId: 5,
          price: "3.558",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Melissa Hill",
          modifiedOn: "02/10/2026",
        },
        {
          id: 53,
          fuelPriceId: 5,
          price: "3.528",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Jeffrey Scott",
          modifiedOn: "02/03/2026",
        },
        {
          id: 54,
          fuelPriceId: 5,
          price: "3.568",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Laura Green",
          modifiedOn: "01/27/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 5,
        pageSize: 7,
      },
    },
  },
  6: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 60,
          fuelPriceId: 6,
          price: "3.798",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Andrew Adams",
          modifiedOn: "02/24/2026",
        },
        {
          id: 61,
          fuelPriceId: 6,
          price: "3.668",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Cynthia Baker",
          modifiedOn: "02/17/2026",
        },
        {
          id: 62,
          fuelPriceId: 6,
          price: "3.618",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Ryan Nelson",
          modifiedOn: "02/10/2026",
        },
        {
          id: 63,
          fuelPriceId: 6,
          price: "3.598",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Ashley Carter",
          modifiedOn: "02/03/2026",
        },
        {
          id: 64,
          fuelPriceId: 6,
          price: "3.638",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Brandon Mitchell",
          modifiedOn: "01/27/2026",
        },
        {
          id: 65,
          fuelPriceId: 6,
          price: "3.688",
          effectiveDate: "01/19/2026",
          createdBy: "System",
          createdOn: "01/19/2026",
          modifiedBy: "Heather Perez",
          modifiedOn: "01/20/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 6,
        pageSize: 7,
      },
    },
  },
  7: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 70,
          fuelPriceId: 7,
          price: "3.489",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Matthew Roberts",
          modifiedOn: "02/24/2026",
        },
        {
          id: 71,
          fuelPriceId: 7,
          price: "3.409",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Kimberly Turner",
          modifiedOn: "02/17/2026",
        },
        {
          id: 72,
          fuelPriceId: 7,
          price: "3.369",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Joshua Phillips",
          modifiedOn: "02/10/2026",
        },
        {
          id: 73,
          fuelPriceId: 7,
          price: "3.339",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Amy Campbell",
          modifiedOn: "02/03/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 4,
        pageSize: 7,
      },
    },
  },
  8: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 80,
          fuelPriceId: 8,
          price: "3.683",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Eric Parker",
          modifiedOn: "02/24/2026",
        },
        {
          id: 81,
          fuelPriceId: 8,
          price: "3.603",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Samantha Evans",
          modifiedOn: "02/17/2026",
        },
        {
          id: 82,
          fuelPriceId: 8,
          price: "3.563",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Jacob Edwards",
          modifiedOn: "02/10/2026",
        },
        {
          id: 83,
          fuelPriceId: 8,
          price: "3.533",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Christina Collins",
          modifiedOn: "02/03/2026",
        },
        {
          id: 84,
          fuelPriceId: 8,
          price: "3.573",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Nicholas Stewart",
          modifiedOn: "01/27/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 5,
        pageSize: 7,
      },
    },
  },
  9: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 90,
          fuelPriceId: 9,
          price: "4.465",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Tyler Sanchez",
          modifiedOn: "02/24/2026",
        },
        {
          id: 91,
          fuelPriceId: 9,
          price: "4.385",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Megan Morris",
          modifiedOn: "02/17/2026",
        },
        {
          id: 92,
          fuelPriceId: 9,
          price: "4.345",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Aaron Rogers",
          modifiedOn: "02/10/2026",
        },
        {
          id: 93,
          fuelPriceId: 9,
          price: "4.315",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Lauren Reed",
          modifiedOn: "02/03/2026",
        },
        {
          id: 94,
          fuelPriceId: 9,
          price: "4.355",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Jordan Cook",
          modifiedOn: "01/27/2026",
        },
        {
          id: 95,
          fuelPriceId: 9,
          price: "4.405",
          effectiveDate: "01/19/2026",
          createdBy: "System",
          createdOn: "01/19/2026",
          modifiedBy: "Alexis Morgan",
          modifiedOn: "01/20/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 6,
        pageSize: 7,
      },
    },
  },
  10: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 100,
          fuelPriceId: 10,
          price: "4.050",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Nathan Bell",
          modifiedOn: "02/24/2026",
        },
        {
          id: 101,
          fuelPriceId: 10,
          price: "3.970",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Victoria Murphy",
          modifiedOn: "02/17/2026",
        },
        {
          id: 102,
          fuelPriceId: 10,
          price: "3.930",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Justin Bailey",
          modifiedOn: "02/10/2026",
        },
        {
          id: 103,
          fuelPriceId: 10,
          price: "3.900",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Brittany Rivera",
          modifiedOn: "02/03/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 4,
        pageSize: 7,
      },
    },
  },
  11: {
    success: true,
    message: "Fuel price history retrieved successfully",
    errorCode: null,
    item: {
      history: [
        {
          id: 110,
          fuelPriceId: 11,
          price: "4.944",
          effectiveDate: "02/23/2026",
          createdBy: "System",
          createdOn: "02/23/2026",
          modifiedBy: "Austin Cooper",
          modifiedOn: "02/24/2026",
        },
        {
          id: 111,
          fuelPriceId: 11,
          price: "4.864",
          effectiveDate: "02/16/2026",
          createdBy: "System",
          createdOn: "02/16/2026",
          modifiedBy: "Hannah Richardson",
          modifiedOn: "02/17/2026",
        },
        {
          id: 112,
          fuelPriceId: 11,
          price: "4.824",
          effectiveDate: "02/09/2026",
          createdBy: "System",
          createdOn: "02/09/2026",
          modifiedBy: "Zachary Cox",
          modifiedOn: "02/10/2026",
        },
        {
          id: 113,
          fuelPriceId: 11,
          price: "4.794",
          effectiveDate: "02/02/2026",
          createdBy: "System",
          createdOn: "02/02/2026",
          modifiedBy: "Katherine Howard",
          modifiedOn: "02/03/2026",
        },
        {
          id: 114,
          fuelPriceId: 11,
          price: "4.834",
          effectiveDate: "01/26/2026",
          createdBy: "System",
          createdOn: "01/26/2026",
          modifiedBy: "Kyle Ward",
          modifiedOn: "01/27/2026",
        },
        {
          id: 115,
          fuelPriceId: 11,
          price: "4.884",
          effectiveDate: "01/19/2026",
          createdBy: "System",
          createdOn: "01/19/2026",
          modifiedBy: "Olivia Torres",
          modifiedOn: "01/20/2026",
        },
        {
          id: 116,
          fuelPriceId: 11,
          price: "4.924",
          effectiveDate: "01/12/2026",
          createdBy: "System",
          createdOn: "01/12/2026",
          modifiedBy: "Sean Peterson",
          modifiedOn: "01/13/2026",
        },
      ],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 7,
        pageSize: 7,
      },
    },
  },
};
